module.exports = __webpack_public_path__ + "static/media/rebate.04b9279c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rebate.svg
// module id = 129
// module chunks = 0